// export const OTHER = '#6A6C7C';
// export const NEUTRAL = '#E7E7E7';
// export const TIE = '#666666';

// export const YES = '#73a8a7';
// export const NO = '#e9c368';
// export const NEWSOM = '#a7c8e0';
// export const SHELLENBERGER = '#BDB3CC';
// export const SENUM = '#BDB3CC';
// export const DAHLE = '#f9c0be';
// export const COLLINS = '#f9c0be';
// export const LE_ROUX = '#f9c0be';
// export const WILLIAMS = '#f9c0be';

// const colorLookup = new Map([
//   // ['polid-2', YES],
//   // ['polid-3', NO],
//   ['polid-60374', NEWSOM],

//   ['polid-66508', SHELLENBERGER], // NPP
//   ['polid-70697', SENUM],

//   ['polid-70689', DAHLE], //GOP
//   ['polid-70687', COLLINS],
//   ['polid-69777', LE_ROUX],
//   ['polid-70702', WILLIAMS],
// ]);

// export function getColor(/** @type {string} */ apId) {
//   return colorLookup.get(apId) || OTHER;
// }

// for the map

export const GOP = '#f27e7d';
export const GOP_DARK = '#f9c1c1';
export const GOP_LIGHT = '#f9c0be';
export const DEMOCRAT = '#5788b8';
export const DEMOCRAT_DARK = '#abc3db';
export const DEMOCRAT_LIGHT = '#a7c8e0';
export const GREEN = '#7BC8AF';
export const LIBERTARIAN = '#EDDB80';
// export const OTHER = '#BCB1CB';
export const OTHER = '#8e9fa9b3';
export const NEUTRAL = '#E7E7E7';
// export const TIE = '#666666';
export const TIE = '#f9cd61';

const colorLookup = new Map([
  ['gop', GOP],
  ['dem', DEMOCRAT],
  // ['gre', GREEN],
  // ['lib', LIBERTARIAN],
]);

const caColorLookup = new Map([
  ['gop', GOP_LIGHT],
  ['dem', DEMOCRAT_LIGHT],
  // ['gre', GREEN],
  // ['lib', LIBERTARIAN],
]);

export function getColor(party) {
  return colorLookup.get(party) || OTHER;
}

export function getCAColor(party) {
  return caColorLookup.get(party) || OTHER;
}

const hatchFillCache = new Map();

export function createHatchFill(fillStyle) {
  if (hatchFillCache.has(fillStyle)) {
    return hatchFillCache.get(fillStyle);
  }

  const patternSize = 7;
  const divisions = 4;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const dpi = window.devicePixelRatio || 1;

  ctx.scale(dpi, dpi);

  canvas.width = patternSize;
  canvas.height = patternSize;

  if (fillStyle === GOP) {
    ctx.fillStyle = GOP_DARK;
    ctx.fillRect(0, 0, patternSize, patternSize);
  }

  if (fillStyle === DEMOCRAT) {
    ctx.fillStyle = DEMOCRAT_DARK;
    ctx.fillRect(0, 0, patternSize, patternSize);
  }

  ctx.fillStyle = fillStyle;

  // Top line
  ctx.beginPath();
  ctx.moveTo(0, patternSize * (1 / divisions));
  ctx.lineTo(patternSize * (1 / divisions), 0);
  ctx.lineTo(0, 0);
  ctx.lineTo(0, patternSize * (1 / divisions));
  ctx.fill();
  ctx.closePath();

  // Middle line
  ctx.beginPath();
  ctx.moveTo(patternSize, patternSize * (1 / divisions));
  ctx.lineTo(patternSize * (1 / divisions), patternSize);
  ctx.lineTo(0, patternSize);
  ctx.lineTo(0, patternSize * ((divisions - 1) / divisions));
  ctx.lineTo(patternSize * ((divisions - 1) / divisions), 0);
  ctx.lineTo(patternSize, 0);
  ctx.lineTo(patternSize, patternSize * (1 / divisions));
  ctx.fill();
  ctx.closePath();

  // Bottom line
  ctx.beginPath();
  ctx.moveTo(patternSize, patternSize * ((divisions - 1) / divisions));
  ctx.lineTo(patternSize * ((divisions - 1) / divisions), patternSize);
  ctx.lineTo(patternSize, patternSize);
  ctx.lineTo(patternSize, patternSize * ((divisions - 1) / divisions));
  ctx.fill();
  ctx.closePath();

  const pattern = ctx.createPattern(canvas, 'repeat');

  hatchFillCache.set(fillStyle, pattern);
  return pattern;
}
